const messages = {
    //Auth
    unknown_user: 'E-Mail not found',
    code_not_found_or_expired: 'Code not found or expired',
};

export default (key) => {
    if (!messages[key]) {
        return key;
    }
    return messages[key];
};
